import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { BasketballTeam, SelectOption } from '@hefe/models';
import { BasketballTeamsSlice } from '@hefe/store';
import { colors } from '@hefe/ui';
import { Button, Modal, Popconfirm, Space, Spin } from 'antd';
import { t } from '@hefe/i18n';
import { useState } from 'react';
import { useAppDispatch } from '../../../../../store/store';
import TeamSettingsComponent from '../team-settings/team-settings.component';

interface TeamsMoreActionsComponentProps {
  team: BasketballTeam;
  coaches: SelectOption[];
}

export default function TeamsMoreActionsComponent(
  props: TeamsMoreActionsComponentProps
) {
  const dispatch = useAppDispatch();
  const [isSettingsModalOpen, setSettingsModalOpen] = useState(false);
  const [isDeleting, setDeleting] = useState(false);

  const deleteTeam = () => {
    setDeleting(true);
    dispatch(BasketballTeamsSlice.deleteBasketballTeam(props.team))
      .unwrap()
      .catch(() => null)
      .finally(() => setDeleting(false));
  };

  const openTeamSettings = () => {
    setSettingsModalOpen(true);
  };

  return (
    <Space>
      <Button
        type="link"
        size="small"
        icon={<EditOutlined />}
        onClick={() => openTeamSettings()}
      />
      <Popconfirm
        title={t('delete') + '?'}
        onConfirm={() => deleteTeam()}
        disabled={isDeleting}
      >
        <Button
          type="link"
          size="small"
          icon={isDeleting ? <Spin size="small" /> : <DeleteOutlined />}
        />
      </Popconfirm>
      <Modal
        open={isSettingsModalOpen}
        title={props.team.name}
        onOk={() => setSettingsModalOpen(false)}
        onCancel={() => setSettingsModalOpen(false)}
        okText={t('ok')}
        cancelButtonProps={{ hidden: true }}
        width={1000}
        bodyStyle={{ backgroundColor: colors.lightgrey }}
        zIndex={10}
      >
        <TeamSettingsComponent team={props.team} coaches={props.coaches} />
      </Modal>
    </Space>
  );
}
